"use strict";
/**
 * Copyright 2019 the orbs-ethereum-contracts authors
 * This file is part of the orbs-ethereum-contracts library in the Orbs project.
 *
 * This source code is licensed under the MIT license found in the LICENSE file in the root directory of this source tree.
 * The above notice should be included in all copies or substantial portions of the software.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingService = void 0;
var StakingContract_json_1 = __importDefault(require("@orbs-network/orbs-ethereum-contracts-v2/build/contracts/StakingContract.json"));
var mainnetAddresses_1 = require("../mainnetAddresses");
var __1 = require("../..");
var MAIN_NET_STAKING_ADDRESS = mainnetAddresses_1.ORBS_MAIN_NET_CONTRACT_ADDRESSES.staking;
var StakingService = /** @class */ (function () {
    function StakingService(web3, stakingContractAddress) {
        if (stakingContractAddress === void 0) { stakingContractAddress = MAIN_NET_STAKING_ADDRESS; }
        this.web3 = web3;
        this.stakingContractAddress = stakingContractAddress;
        this.stakingContract = new this.web3.eth.Contract(StakingContract_json_1.default.abi, this.stakingContractAddress);
    }
    // CONFIG //
    StakingService.prototype.setFromAccount = function (address) {
        this.stakingContract.options.from = address;
    };
    StakingService.prototype.getStakingContractAddress = function () {
        return this.stakingContractAddress;
    };
    // WRITE //
    StakingService.prototype.stake = function (amount) {
        return this.stakingContract.methods.stake(amount.toString()).send();
    };
    StakingService.prototype.unstake = function (amount) {
        return this.stakingContract.methods.unstake(amount.toString()).send();
    };
    StakingService.prototype.restake = function () {
        return this.stakingContract.methods.restake().send();
    };
    StakingService.prototype.withdraw = function () {
        return this.stakingContract.methods.withdraw().send();
    };
    // READ //
    StakingService.prototype.readTotalStakedInFullOrbs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var totalStaked, totalStakedInFullOrbs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stakingContract.methods.getTotalStakedTokens().call()];
                    case 1:
                        totalStaked = _a.sent();
                        totalStakedInFullOrbs = __1.fullOrbsFromWeiOrbs(totalStaked);
                        return [2 /*return*/, totalStakedInFullOrbs];
                }
            });
        });
    };
    StakingService.prototype.readStakeBalanceOf = function (stakeOwner) {
        return __awaiter(this, void 0, void 0, function () {
            var stakedBalance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stakingContract.methods.getStakeBalanceOf(stakeOwner).call()];
                    case 1:
                        stakedBalance = _a.sent();
                        return [2 /*return*/, BigInt(stakedBalance)];
                }
            });
        });
    };
    StakingService.prototype.readTotalStakedTokens = function () {
        return __awaiter(this, void 0, void 0, function () {
            var totalStakedTokens;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stakingContract.methods.getTotalStakedTokens().call()];
                    case 1:
                        totalStakedTokens = _a.sent();
                        return [2 /*return*/, BigInt(totalStakedTokens)];
                }
            });
        });
    };
    StakingService.prototype.readUnstakeStatus = function (stakeOwner) {
        return __awaiter(this, void 0, void 0, function () {
            var result, cooldownAmountBigInt, cooldownEndTimeNumber;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stakingContract.methods.getUnstakeStatus(stakeOwner).call()];
                    case 1:
                        result = _a.sent();
                        cooldownAmountBigInt = BigInt(result.cooldownAmount);
                        cooldownEndTimeNumber = Number(result.cooldownEndTime);
                        // DEV_NOTE : NaN means that the given stake owner has no "active" cooldown process.
                        // DEV_NOTE : We have removed the check for "typeof cooldownAmountBigInt != 'bigint'" in order to support polyfills
                        //            of Bigint.
                        if (Number.isNaN(cooldownEndTimeNumber)) {
                            cooldownAmountBigInt = BigInt(0);
                            cooldownEndTimeNumber = 0;
                        }
                        return [2 /*return*/, {
                                cooldownAmount: cooldownAmountBigInt,
                                cooldownEndTime: cooldownEndTimeNumber,
                            }];
                }
            });
        });
    };
    // Events Subscriptions //
    StakingService.prototype.subscribeToStakedEvent = function (stakeOwner, callback) {
        var eventSubscriptionFunction = this.stakingContract.events.Staked;
        return this.subscribeToStakingContractEvent(eventSubscriptionFunction, stakeOwner, callback);
    };
    StakingService.prototype.subscribeToUnstakedEvent = function (stakeOwner, callback) {
        var eventSubscriptionFunction = this.stakingContract.events.Unstaked;
        return this.subscribeToStakingContractEvent(eventSubscriptionFunction, stakeOwner, callback);
    };
    StakingService.prototype.subscribeToRestakedEvent = function (stakeOwner, callback) {
        var eventSubscriptionFunction = this.stakingContract.events.Restaked;
        return this.subscribeToStakingContractEvent(eventSubscriptionFunction, stakeOwner, callback);
    };
    StakingService.prototype.subscribeToWithdrewEvent = function (stakeOwner, callback) {
        var eventSubscriptionFunction = this.stakingContract.events.Withdrew;
        return this.subscribeToStakingContractEvent(eventSubscriptionFunction, stakeOwner, callback);
    };
    /**
     * Dev Note : O.L : This function should be extracted and isolated for testing purpose.
     * Dev Note #2 : All the events of the 'Staking contract' have exactly the same signature.
     */
    StakingService.prototype.subscribeToStakingContractEvent = function (eventSubscriptionFunction, stakeOwner, callback) {
        var specificEventEmitter = eventSubscriptionFunction({
            filter: {
                stakeOwner: [stakeOwner],
            },
        }, function (error, event) {
            if (error) {
                callback(error, BigInt(0), BigInt(0));
                return;
            }
            callback(null, BigInt(event.returnValues.amount), BigInt(event.returnValues.totalStakedAmount));
        });
        // DEV_NOTE : O.L : This was taken directly from the old 'orbs-pos-data'.
        //                  it seems that the contracts generated types are using the nodejs 'EventEmitter' type.
        //                  we should check for inconsistencies.
        // TODO : O.L : Ensure this works properly
        // @ts-ignore
        return function () { return getUnsubscribePromise(specificEventEmitter); };
    };
    return StakingService;
}());
exports.StakingService = StakingService;
//# sourceMappingURL=StakingService.js.map